import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {showPreviewForCreativeId} from '../../../../store/creativesLibrary/creativesLibrary.slice';
import {CreativesManagerAgentToolName} from '../creativesManagerAgent.enums';

const inputSchema = z.object({
  creativeId: z.number(),
});

function showCreativePreviewTool(store: CLStore) {
  async function execute({
    input: {creativeId},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const creatives = store.getState().creativesLibrary.creatives;
    const isCreativeIdValid = creatives.some((creative) => creative.id === creativeId);

    if (!isCreativeIdValid) {
      return toolResult(`Creative with ID ${creativeId} not found in the creatives library.`);
    }

    store.dispatch(showPreviewForCreativeId(creativeId));

    return toolResult('Showing preview for creative ID: ' + creativeId);
  }

  return tool({
    name: CreativesManagerAgentToolName.ShowCreativePreview,
    description: 'Show the preview of given creative ID. Must navigate to creatives library first',
    displayName: 'Showing creative preview',
    execute,
    inputSchema,
  });
}

export default showCreativePreviewTool;
